export default __webpack_public_path__ + "static/media/institute-19-min.a9bc4f10.webp";